<template>
  <BaseDialog type="basic" :is-open="isOpen" @close="close">
    <p class="text-body-medium text-on-surface-variant mt-6">{{ questionText }}</p>
    <div class="mt-4 mb-1 flex flex-row items-center gap-2">
      <BaseMemberAvatar :member="member" size="40" />
      <span class="text-label-large grow">{{ memberFullName(member) }}</span>
      <JournalAnalysisValueBar :value="feedbackValue" />
    </div>
    <div
      class="bg-secondary-container rounded-large rounded-tl-extra-small text-on-secondary-container p-4"
    >
      <WysiwygTextFieldReadOnly
        v-if="feedbackText"
        :value="feedbackText"
        class="text-body-medium"
      />
    </div>
    <template #dismiss>
      <BaseTextButton color="text" @click="close">{{ $t('common.close') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import type { JSONContent } from '@tiptap/vue-3'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import { memberFullName } from '@/core/models/member/member-name'
  import BaseDialog from '../base/dialog/BaseDialog.vue'
  import BaseTextButton from '../base/button/text-button/BaseTextButton.vue'
  import BaseMemberAvatar from '../base/avatar/BaseMemberAvatar.vue'
  import WysiwygTextFieldReadOnly from '../base/wysiwyg/WysiwygTextFieldReadOnly.vue'
  import JournalAnalysisValueBar from './JournalAnalysisValueBar.vue'

  interface Props {
    isOpen: boolean
    member: MemberOrUser
    questionText: string
    feedbackText: JSONContent | null
    feedbackValue: number | null
  }

  defineProps<Props>()

  const emit = defineEmits<{
    close: []
  }>()

  const close = () => {
    emit('close')
  }
</script>
